import angular from "angular";

import { Dates, TaxcardListItem, Taxcard, Taxcards, WorkerCurrentTaxcards } from "@salaxy/core";
import { EditDialogKnownActions, UiHelpers } from "../../services";

/**
 * Helps listing current all tax cards for an employment relation (latest and previous ones).
 */
export class EmploymentTaxcardsController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["Taxcards", "UiHelpers"];

  /** The data after it has been loaded. Null if nothing is loaded yet.  */
  public current: WorkerCurrentTaxcards;

  /**
   * View mode:
   *
   * - "active" only shows the active taxcard.
   * - "list" only shows the history list.
   * - "all" (default) shows both active and history.
   */
  public mode: "active" | "list" | "all";

  /**
   * Today is explicitly defined, so that it can be changed in testing.
   */
  public today = Dates.getToday();

  /** If true, does not show the save / current buttons - the parent must show them. */
  public hideButtons: boolean;

  /**
   * Event that is called when a taxcard is saved and the parent UI probably needs to be refreshed.
   * @example <salaxy-employment-taxcards employment-id="$ctrl.current.employmentId" on-save="$ctrl.refresh()"></salaxy-employment-taxcards>
   */
   public onSave: (eventData: {
    /** The selected item. */
    item: Taxcard,
  }) => void;

  private _employmentId: string;

  /** Creates a new EmploymentTaxcardsController */
  constructor(
    private taxcards: Taxcards,
    private uiHelpers: UiHelpers) { }

  /** Initializes the controller. */
  public $onInit = () => {
    this.mode = this.mode || "all";
  };

  /**
   * Defines to which employment relation the functionality is bound to.
   * The setter also starts the loading process.
   */
  public get employmentId(): string {
    return this._employmentId;
  }
  public set employmentId(value: string) {
    this._employmentId = value;
    this.reload();
  }

  /** List of taxcards after it has been loaded. Null if nothing is loaded yet. */
  public get list(): TaxcardListItem[] {
    if (this.current) {
      return this.current.list;
    }
    return null;
  }

  /** Reloads the data from the server. */
  public reload() {
    this.current = null;
    if (this.employmentId) {
      this.taxcards.getEmploymentTaxcards(this.employmentId, this.today).then((result) => {
        this.current = result;
      });
    }
  }

  /**
   * Removes a taxcard from the list and does a refresh.
   * @param id Taxcard id.
   */
  public deleteTaxCard(id: string) {
    this.taxcards.delete(id).then(() => {
      this.reload();
    });
  }

  /** Edit income log. */
  public editIncomeLog() {
    this.uiHelpers.openEditDialog("salaxy-components/modals/worker/taxcard-income-log.html", this.current.active,
    { editable: true }, "lg").then((result) => {
      if (result.action === EditDialogKnownActions.Ok) {
        const loader = this.uiHelpers.showLoading("SALAXY.UI_Terms.pleaseWait");
        this.taxcards.save(this.current.active).then((taxcard) => {
          loader.dismiss();
          this.reload();
          if (this.onSave) {
            this.onSave({ item: taxcard});
          }
        });
      }
    });
  }

}
